import {
  IconDotsHorizontal,
  Menu,
  type MenuItemSection,
} from '@leland-dev/leland-ui-library';
import React from 'react';

export interface CustomButtonProps {
  onClick?: () => void;
}

interface ThreeDotMenuProps {
  itemSections: MenuItemSection[];
}

const ThreeDotMenu: React.FC<ThreeDotMenuProps> = ({ itemSections }) => {
  return (
    <Menu asChild itemSections={itemSections}>
      <button type="button" id="three_dot_menu:button">
        <IconDotsHorizontal className="pointer-events-none size-5 text-leland-gray-light" />
      </button>
    </Menu>
  );
};

export default ThreeDotMenu;
